import { ChartStrategy } from './types';
import { dailyBlastStrategy } from './dailyBlast';
import { rockBandStrategy } from './rockBand';
import { sniperStrategy } from './sniper';
import { shavedDojiStrategy } from './shavedDoji';
import { thetaMinerStrategy } from './thetaMiner';
import { bhairavStrategy } from './bhairav';
import { omStrategy } from './om';
import { omSimpleStrategy } from './omSimple';
import { vajraStrategy } from './vajra';
import { clnBreakStrategy } from './clnBreak';
import { gandivStrategy } from './gandiv';
import { lrCrossStrategy } from './lrCross';

export type { ChartStrategy, StrategyOverlayResult, CandleColor, OverlayLine, ChartMarker, ChartStrategyOptions } from './types';
export { dailyBlastStrategy } from './dailyBlast';
export { sniperStrategy, computeSniperOverlay } from './sniper';
export { rockBandStrategy, computeRockBandOverlay } from './rockBand';
export { shavedDojiStrategy, computeShavedDojiOverlay } from './shavedDoji';
export { thetaMinerStrategy, computeThetaMinerOverlay } from './thetaMiner';
export { bhairavStrategy, computeBhairavOverlay } from './bhairav';
export { omStrategy, computeOmOverlay, computeOmSteps } from './om';
export { omSimpleStrategy, computeOmSimpleOverlay } from './omSimple';
export { computeOmSimpleSteps, OM_SIMPLE_DEFAULT_CLN_LENGTH } from './omSimpleEngine';
export { vajraStrategy, computeVajraOverlay } from './vajra';
export { computeVajraTrades, VAJRA_DEFAULTS } from './vajraEngine';
export { clnBreakStrategy, computeClnBreakOverlay, computeClnBreakSeries, resolveClnBreakOptions } from './clnBreak';
export {
  computeClnBreakSteps, computeClnBreakTrades,
  CLN_BREAK_DEFAULT_CLN_LENGTH, CLN_BREAK_DEFAULT_LOOKBACK, CLN_BREAK_ATR_PERIOD,
} from './clnBreakEngine';
export { gandivStrategy, computeGandivOverlay, GANDIV_DEFAULTS, resolveGandivSource } from './gandiv';
export { computeGandivTrades } from './gandivEngine';
export { lrCrossStrategy, computeLrCrossOverlay } from './lrCross';
export { computeLrCrossSteps, resolveLrCrossSource, LR_CROSS_OPTION_HINT } from './lrCrossEngine';

/**
 * Raw-candles strategy — emits nothing. Selected by default so a fresh user
 * sees unadorned candles until they pick a real strategy (v3 plan item 15).
 */
export const rawCandlesStrategy: ChartStrategy = {
  id: 'none',
  name: 'Raw',
  computeOverlays() {
    return { candleColors: [], markers: [] };
  },
};

// Chart strategy selector (order = dropdown order).
export const strategies: ChartStrategy[] = [
  rawCandlesStrategy,
  rockBandStrategy,
  sniperStrategy,
  dailyBlastStrategy,
  shavedDojiStrategy,
  thetaMinerStrategy,
  bhairavStrategy,
  omStrategy,
  omSimpleStrategy,
  vajraStrategy,
  clnBreakStrategy,
  gandivStrategy,
  lrCrossStrategy,
];

export function getStrategy(id: string): ChartStrategy | undefined {
  return strategies.find(s => s.id === id);
}
